var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    ref: "vueModal",
    attrs: {
      "name": "shareYourDesignModal",
      "pivotY": 0.15,
      "width": "350px",
      "height": "auto",
      "scrollable": true,
      "classes": ['generic-modals', 'v--modal', 'modals-share-your-design']
    },
    on: {
      "before-open": _vm.beforeOpen,
      "before-close": _vm.beforeClose
    }
  }, [_c('section', {
    staticClass: "modals-share-your-design"
  }, [_c('div', {
    class: ['modals-share-your-design-wrapper', {
      hide: !_vm.hideConfirmationModal
    }]
  }, [_c('h2', {
    staticClass: "modals-share-your-design-title"
  }, [_vm._v(_vm._s(_vm.translations.shareYourDesignTitle))]), _c('div', {
    staticClass: "modals-share-your-design-text"
  }, [_vm._v("\n        " + _vm._s(_vm.translations.shareYourDesignText1) + " "), _c('br'), _vm._v("\n        " + _vm._s(_vm.translations.shareYourDesignText2) + "\n      ")]), _c('div', {
    staticClass: "modals-share-your-design-share-area"
  }, [_c('button', {
    staticClass: "modals-share-your-design-share-area-copy-link",
    attrs: {
      "disabled": _vm.recipeIsLoading
    },
    on: {
      "click": _vm.copyLink,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('span', {
    staticClass: "icon-share modals-share-your-design-share-area-copy-link-icon"
  }), _c('span', {
    staticClass: "modals-share-your-design-share-area-copy-link-text"
  }, [_vm._v("\n            " + _vm._s(_vm.translations.shareYourDesignCopyLink) + "\n          ")])]), _c('div', {
    ref: "copyMessage",
    staticClass: "modals-share-your-design-share-area-copy-message"
  }, [_vm._v(_vm._s(_vm.translations.shareYourDesignCopyLinkM))])]), _c('div', {
    staticClass: "large-12 columns"
  }, [_c('form', {
    ref: "form",
    staticClass: "modals-share-your-design-form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.sendMessage.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "modals-share-your-design-form-modal-scroll-area"
  }, [_c('div', {
    staticClass: "required-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.shareDesignFormData.from_name,
      expression: "shareDesignFormData.from_name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "64",
      "id": "input_name",
      "placeholder": _vm.translations.shareYourDesignName,
      "required": ""
    },
    domProps: {
      "value": _vm.shareDesignFormData.from_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shareDesignFormData, "from_name", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "required-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.shareDesignFormData.from_email,
      expression: "shareDesignFormData.from_email"
    }],
    attrs: {
      "type": "email",
      "maxlength": "250",
      "id": "input_email",
      "placeholder": _vm.translations.shareYourDesignEmail,
      "required": ""
    },
    domProps: {
      "value": _vm.shareDesignFormData.from_email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shareDesignFormData, "from_email", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._l(_vm.addAnotherRecipients, function (recipient, index) {
    return _c('div', {
      key: index,
      staticClass: "modals-share-your-design-form-add-recipient-container"
    }, [_c('div', {
      staticClass: "required-input",
      attrs: {
        "data-id": index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: recipient.emailAddress,
        expression: "recipient.emailAddress"
      }],
      attrs: {
        "type": "email",
        "maxlength": "250",
        "id": "input_recipients_".concat(index),
        "placeholder": _vm.translations.shareYourDesignRecipient,
        "required": ""
      },
      domProps: {
        "value": recipient.emailAddress
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(recipient, "emailAddress", $event.target.value);
        }
      }
    }), index != 0 ? _c('div', {
      staticClass: "modals-share-your-design-form-add-recipient-container-close",
      on: {
        "click": function click($event) {
          return _vm.removeRecipient(index);
        }
      }
    }, [_c('span', {
      staticClass: "icon-close"
    })]) : _vm._e(), _c('span', {
      staticClass: "req"
    }, [_vm._v("*")])])]);
  }), _c('div', {
    staticClass: "modals-share-your-design-form-add-another-area"
  }, [_c('button', {
    staticClass: "add-another",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.addRecipient.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus"
  }), _c('span', {
    staticClass: "add-another-text"
  }, [_vm._v(_vm._s(_vm.translations.shareYourDesignAddAnother))])]), _vm._v(" "), _c('span', {
    staticClass: "max-add-another-text"
  }, [_vm._v(_vm._s(_vm.translations.shareYourDesignMaxSize))])]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.shareDesignFormData.message,
      expression: "shareDesignFormData.message"
    }],
    staticClass: "modals-share-your-design-form-textarea-message",
    attrs: {
      "maxlength": "2000",
      "id": "textarea_message",
      "placeholder": _vm.translations.shareYourDesignMessage
    },
    domProps: {
      "value": _vm.shareDesignFormData.message
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shareDesignFormData, "message", $event.target.value);
      }
    }
  })], 2), _c('div', {
    staticClass: "modals-share-your-design-form-check"
  }, [_c('label', {
    staticClass: "modals-share-your-design-form-check-label",
    attrs: {
      "for": "checkbox1"
    }
  }, [_c('input', {
    attrs: {
      "id": "checkbox1",
      "name": "newsletter",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.enableCheck
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.translations.shareYourDesignCheckBoxM) + " ")])])]), !_vm.recaptchaVerified && !!_vm.configuration.enableRecaptcha ? _c('vue-recaptcha', {
    ref: "recaptchaShareCustomizer",
    attrs: {
      "id": "recaptcha",
      "loadRecaptchaScript": true,
      "sitekey": _vm.recaptchaKey
    },
    on: {
      "verify": _vm.onVerifyRecaptcha,
      "error": _vm.errorRecaptcha
    }
  }) : _vm._e(), _c('div', {
    staticClass: "modals-share-your-design-form-button-wrapper"
  }, [_c('button', {
    staticClass: "modals-share-your-design-form-send button primary",
    attrs: {
      "disabled": _vm.disableSendButton,
      "type": "submit",
      "id": "submit_button"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.translations.shareYourDesignSend) + "\n            ")])])], 1)]), _c('button', {
    staticClass: "close-button",
    attrs: {
      "id": "close-button-shareYourDesignModal",
      "title": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _c('div', {
    class: ['modals-share-your-design-message-sent', {
      hide: _vm.hideConfirmationModal
    }]
  }, [_c('h2', {
    staticClass: "modals-share-your-design-message-sent-title-text"
  }, [_vm._v("\n        " + _vm._s(_vm.translations.shareYourDesignSendMessage) + "\n      ")]), _c('div', {
    staticClass: "modals-share-your-design-message-sent-design-text"
  }, [_vm._v("\n        " + _vm._s(_vm.translations.shareYourDesignSendText) + "\n      ")]), _c('button', {
    staticClass: "close-button",
    attrs: {
      "id": "close-button-message-shareYourDesignModal",
      "title": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }